import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WelcomeLocationModal from "@/components/WelcomeLocationModal";
import CookieBanner from "@/components/CookieBanner";
import VipPopup from "@/components/VipPopup";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#ffffff]">
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <WelcomeLocationModal />
      <CookieBanner />
      <VipPopup />
    </div>
  );
}
